module.exports = __webpack_public_path__ + "img/vertical-align.35c5889d.svg";